import api from "./api";
import { useMainStore } from "@/stores/store";

export default {
    async getDailyCredits(year, week) {
        const mainStore = useMainStore();
        const companyId = mainStore.companypage.id;
        return await api.get(`/v1/users/${companyId}/credits?year=${year}&week=${week}`);
    },

    async getWeeklyCredits(year, month) {
        const mainStore = useMainStore();
        const companyId = mainStore.companypage.id;
        return await api.get(`/v1/users/${companyId}/credits?year=${year}&month=${month}`);
    },

    async getMonthlyCredits(year) {
        const mainStore = useMainStore();
        const companyId = mainStore.companypage.id;
        return await api.get(`/v1/users/${companyId}/credits?year=${year}`);
    },

    async getYearlyCredits() {
        const mainStore = useMainStore();
        const companyId = mainStore.companypage.id;
        return await api.get(`/v1/users/${companyId}/credits`);
    }
}